import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { api } from "../../../services/api";

export default function CardHeaderPreviewPdf({
  children,
  enterpriseData,
  ...props
}) {
  const [enterprise, setEnterprise] = useState([]);
  useEffect( () => {

    if (enterpriseData) {
      setEnterprise(JSON.parse(enterpriseData))
    }
   
  }, [enterpriseData]);

  return (

    <Box
      sx={{
        borderBottom: 1,
        marginBottom: "15px",
        marginLeft: "45px",
        marginRight: "45px",
        borderColor: "#01A7E1",
      }}
    >
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={2} sm={4} md={8} key={1}>
          <Typography component="h6" sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
            Nome Fantasia
          </Typography>
        </Grid>
        <Grid item xs={2} sm={4} md={2} key={2}>
          <Typography component="h6" sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
            CNPJ
          </Typography>
        </Grid>
        <Grid item xs={2} sm={4} md={2} key={3}>
          <Typography component="h6" sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
            Início das Atividades
          </Typography>
        </Grid>
      </Grid>
      {Object.keys(enterprise)?.map((index) => {
        return (
          <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={8} sm={4} md={8} key={index + 3}>
              <Typography component="h6" sx={{ fontSize: "0.8rem", color:"rgb(0, 50, 160)", textTransform: "uppercase"}}>
                {enterprise[index]?.nome_fantasia}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={4} md={2} key={index + 4}>
              <Typography component="h6" sx={{ fontSize: "0.8rem", color:"rgb(0, 50, 160)", textTransform: "capitalize" }}>
                {enterprise[index]?.pes_cpfcnpj}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={4} md={2} key={index + 5}>
              <Typography component="h6" sx={{ fontSize: "0.8rem", color:"rgb(0, 50, 160)", textTransform: "capitalize" }}>
                {enterprise[index]?.data_inicio}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
      <Grid item sm={12} md={2}>
        {children}
      </Grid>
    </Box>

  );
}
